import { createRef } from "react";
import { ModalRefProps } from "components/Modal/Modal.d";

export default function (): [React.Ref<ModalRefProps>, () => void] {
  const ref = createRef<ModalRefProps>();
  return [ref, () => ref.current!.open()];
}
